import { renderElement } from '@/features/cms/components/CMS/RichTextRenderer'
import { type HeadlineTextEmbedded } from '@/features/cms/components/CMS/types'
import { TextButtonLink } from '@/features/shared/elements/Link/Buttons'
import { spacing } from '@/features/shared/theme/tokens'
import { sanitizeHTML } from '@/features/shared/utils/sanitize'
import { Body } from '@shipt/design-system-typography'
import styled from 'styled-components'
import { theme } from '@/features/shared/constants/shiptTheme'

export const HeadlineTextEmbeddedSection = ({ data }: { data: HeadlineTextEmbedded['data'] }) => {
  const { subheading_rich_text, text, cta_link } = data
  return (
    <>
      {!!subheading_rich_text && (
        <AccordionItem as="div" align="left" variant="secondary">
          {subheading_rich_text.elements.map(renderElement)}
        </AccordionItem>
      )}
      {!!text && !subheading_rich_text && (
        <AccordionItem
          align="left"
          as="div"
          variant="secondary"
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(text),
          }}
        />
      )}
      {!!cta_link?.text && (
        <AccordionLink opensInNewTab={cta_link.open_in_new_tab} href={cta_link.url}>
          {cta_link.text}
        </AccordionLink>
      )}
    </>
  )
}

const AccordionItem = styled(Body)`
  a {
    color: ${theme.color.content.action.primary};

    &:hover,
    &:focus {
      color: ${theme.color.content.action.primary_hover};
    }

    &:active {
      color: ${theme.color.content.action.primary_active};
    }
  }
`

const AccordionLink = styled(TextButtonLink)`
  margin-top: ${spacing('lg')};
`
